/** Espelha LancarFinanceiroNotaFiscalSaidaRequest do OrquestradorVendas (POST NotaFiscalSaida/idNFeSaida/{id}/financeiro/lancar). */
export class LancarFinanceiroNotaFiscalSaidaRequest {
  /** Gerar os boletos das parcelas com forma boleto e conta conectada (custo de bilhetagem). */
  gerarBoletos: boolean = false;
}
